// extracted by mini-css-extract-plugin
export default {"__headerContainer__":"header___headerContainer____t6xM8","__headingText__":"header___headingText____FY0E3"};